// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  transition: background-image 0.5s ease-in-out; /* Smooth transition for background change */
}

/* ---------------------------------------------------------------------------
   "Refresh Card!", brought into the palette.

   It is styled in public/index.html, in a hand-written <style> block full of
   literal cream and burnt orange. Once the launcher beside it started following
   the theme, this was the one piece of daylight left in the header after the
   show called After Dark -- a cream button glowing on a black page.

   Restated here rather than edited there: the selectors are identical, so they
   are the same specificity, and this stylesheet is injected after that block --
   later wins. public/index.html does not have to change at all.

   Colours only. Padding, radius and font are left to the original rules, so the
   button is exactly the same size in every look.
--------------------------------------------------------------------------- */

.inner-rfrsh-btn button {
  background: linear-gradient(to bottom, var(--wsb-surface), var(--wsb-surface-2));
  color: var(--wsb-accent-text);
  box-shadow: inset 0 0 0 1px var(--wsb-ring);
  /* Pinned for the same reason as the launcher beside it: the themes' opening
     \`* { font-family }\` reset changes this label's width, and a header button
     that changes size when the look changes drags the card down with it. */
  font-family: 'Dosis', sans-serif;
}

.inner-rfrsh-btn button:hover {
  background: var(--wsb-surface-hover);
}

.inner-rfrsh-btn a,
.refresh-icon,
.refresh-icon a {
  color: var(--wsb-accent-text);
}

@media (prefers-reduced-motion: no-preference) {
  .inner-rfrsh-btn button {
    transition:
      background-color var(--wsb-swap) ease,
      color var(--wsb-swap) ease,
      box-shadow var(--wsb-swap) ease;
  }
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 5vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* ---------------------------------------------------------------------------
   "Confirmed on air tonight" indicator.

   Lives here rather than in a theme file because App.css is the one stylesheet
   loaded for every theme; the themes are require()d afterwards, and .item plus
   .verified-live outranks their plain .item rules either way.

   Deliberately quiet. The glow rests almost invisible and pulses twice, gently,
   about every 21 seconds -- long enough that it never nags at the corner of
   your eye, often enough that anyone who missed the toast still catches it
   within about half a minute. Squares are staggered in seven groups (a prime,
   so the pattern never lines up with the five-column grid) to avoid the whole
   card breathing in unison.

   Only box-shadow moves: no size, position or background change, so this can
   never be mistaken for the marked (.clicked) state, never shifts layout and
   never intercepts a click. z-index lifts a glowing square above its
   neighbours, which would otherwise paint over the halo.

   The colour of the halo is the theme's, not this file's: warm lamplight on an
   ordinary night, moonlight once the show calls After Dark. The square itself
   is left exactly as the theme draws it -- the cream paper is the product.
--------------------------------------------------------------------------- */

.item.verified-live {
  position: relative;
  z-index: 2;
  box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft);
  animation: verifiedLivePulse 21s ease-in-out infinite;
}

@keyframes verifiedLivePulse {
  0%   { box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft); }
  7%   { box-shadow: 0 0 14px 3px var(--wsb-verified-glow-strong); }
  14%  { box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft); }
  21%  { box-shadow: 0 0 14px 3px var(--wsb-verified-glow-strong); }
  28%  { box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft); }
  100% { box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft); }
}

.item.verified-live:nth-child(7n + 1) { animation-delay: 0s; }
.item.verified-live:nth-child(7n + 2) { animation-delay: 2.1s; }
.item.verified-live:nth-child(7n + 3) { animation-delay: 4.2s; }
.item.verified-live:nth-child(7n + 4) { animation-delay: 6.3s; }
.item.verified-live:nth-child(7n + 5) { animation-delay: 8.4s; }
.item.verified-live:nth-child(7n + 6) { animation-delay: 10.5s; }
.item.verified-live:nth-child(7n)     { animation-delay: 12.6s; }

/* Same information, no movement. */
@media (prefers-reduced-motion: reduce) {
  .item.verified-live {
    animation: none;
    box-shadow: 0 0 10px 1px var(--wsb-verified-glow-strong);
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6CAA6C,EAAE,4CAA4C;AAC7F;;AAEA;;;;;;;;;;;;;;6EAc6E;;AAE7E;EACE,gFAAgF;EAChF,6BAA6B;EAC7B,2CAA2C;EAC3C;;2EAEyE;EACzE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE;IACE;;;qCAGiC;EACnC;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;6EAsB6E;;AAE7E;EACE,kBAAkB;EAClB,UAAU;EACV,mDAAmD;EACnD,qDAAqD;AACvD;;AAEA;EACE,OAAO,mDAAmD,EAAE;EAC5D,OAAO,wDAAwD,EAAE;EACjE,OAAO,mDAAmD,EAAE;EAC5D,OAAO,wDAAwD,EAAE;EACjE,OAAO,mDAAmD,EAAE;EAC5D,OAAO,mDAAmD,EAAE;AAC9D;;AAEA,wCAAwC,mBAAmB,EAAE;AAC7D,wCAAwC,qBAAqB,EAAE;AAC/D,wCAAwC,qBAAqB,EAAE;AAC/D,wCAAwC,qBAAqB,EAAE;AAC/D,wCAAwC,qBAAqB,EAAE;AAC/D,wCAAwC,sBAAsB,EAAE;AAChE,wCAAwC,sBAAsB,EAAE;;AAEhE,mCAAmC;AACnC;EACE;IACE,eAAe;IACf,wDAAwD;EAC1D;AACF","sourcesContent":[".App {\n  text-align: center;\n  transition: background-image 0.5s ease-in-out; /* Smooth transition for background change */\n}\n\n/* ---------------------------------------------------------------------------\n   \"Refresh Card!\", brought into the palette.\n\n   It is styled in public/index.html, in a hand-written <style> block full of\n   literal cream and burnt orange. Once the launcher beside it started following\n   the theme, this was the one piece of daylight left in the header after the\n   show called After Dark -- a cream button glowing on a black page.\n\n   Restated here rather than edited there: the selectors are identical, so they\n   are the same specificity, and this stylesheet is injected after that block --\n   later wins. public/index.html does not have to change at all.\n\n   Colours only. Padding, radius and font are left to the original rules, so the\n   button is exactly the same size in every look.\n--------------------------------------------------------------------------- */\n\n.inner-rfrsh-btn button {\n  background: linear-gradient(to bottom, var(--wsb-surface), var(--wsb-surface-2));\n  color: var(--wsb-accent-text);\n  box-shadow: inset 0 0 0 1px var(--wsb-ring);\n  /* Pinned for the same reason as the launcher beside it: the themes' opening\n     `* { font-family }` reset changes this label's width, and a header button\n     that changes size when the look changes drags the card down with it. */\n  font-family: 'Dosis', sans-serif;\n}\n\n.inner-rfrsh-btn button:hover {\n  background: var(--wsb-surface-hover);\n}\n\n.inner-rfrsh-btn a,\n.refresh-icon,\n.refresh-icon a {\n  color: var(--wsb-accent-text);\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .inner-rfrsh-btn button {\n    transition:\n      background-color var(--wsb-swap) ease,\n      color var(--wsb-swap) ease,\n      box-shadow var(--wsb-swap) ease;\n  }\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 5vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ---------------------------------------------------------------------------\n   \"Confirmed on air tonight\" indicator.\n\n   Lives here rather than in a theme file because App.css is the one stylesheet\n   loaded for every theme; the themes are require()d afterwards, and .item plus\n   .verified-live outranks their plain .item rules either way.\n\n   Deliberately quiet. The glow rests almost invisible and pulses twice, gently,\n   about every 21 seconds -- long enough that it never nags at the corner of\n   your eye, often enough that anyone who missed the toast still catches it\n   within about half a minute. Squares are staggered in seven groups (a prime,\n   so the pattern never lines up with the five-column grid) to avoid the whole\n   card breathing in unison.\n\n   Only box-shadow moves: no size, position or background change, so this can\n   never be mistaken for the marked (.clicked) state, never shifts layout and\n   never intercepts a click. z-index lifts a glowing square above its\n   neighbours, which would otherwise paint over the halo.\n\n   The colour of the halo is the theme's, not this file's: warm lamplight on an\n   ordinary night, moonlight once the show calls After Dark. The square itself\n   is left exactly as the theme draws it -- the cream paper is the product.\n--------------------------------------------------------------------------- */\n\n.item.verified-live {\n  position: relative;\n  z-index: 2;\n  box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft);\n  animation: verifiedLivePulse 21s ease-in-out infinite;\n}\n\n@keyframes verifiedLivePulse {\n  0%   { box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft); }\n  7%   { box-shadow: 0 0 14px 3px var(--wsb-verified-glow-strong); }\n  14%  { box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft); }\n  21%  { box-shadow: 0 0 14px 3px var(--wsb-verified-glow-strong); }\n  28%  { box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft); }\n  100% { box-shadow: 0 0 6px 0 var(--wsb-verified-glow-soft); }\n}\n\n.item.verified-live:nth-child(7n + 1) { animation-delay: 0s; }\n.item.verified-live:nth-child(7n + 2) { animation-delay: 2.1s; }\n.item.verified-live:nth-child(7n + 3) { animation-delay: 4.2s; }\n.item.verified-live:nth-child(7n + 4) { animation-delay: 6.3s; }\n.item.verified-live:nth-child(7n + 5) { animation-delay: 8.4s; }\n.item.verified-live:nth-child(7n + 6) { animation-delay: 10.5s; }\n.item.verified-live:nth-child(7n)     { animation-delay: 12.6s; }\n\n/* Same information, no movement. */\n@media (prefers-reduced-motion: reduce) {\n  .item.verified-live {\n    animation: none;\n    box-shadow: 0 0 10px 1px var(--wsb-verified-glow-strong);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
